import { pinyin } from 'pinyin-pro'

export function toPinyin(text) {
  if (!text) return ''
  return pinyin(text, { toneType: 'none' })
    .replace(/ - /g, '-')
    .replace(/\b\w/g, c => c.toUpperCase())
}

export function formatBuildingName(name, isEn) {
  if (!name) return ''
  if (isEn) {
    if (/^\d+$/.test(name)) return 'Building ' + name
    var m = name.match(/^(\d+)[号幢栋]$/)
    if (m) return 'Building ' + m[1]
    return toPinyin(name)
  } else {
    if (/^\d+$/.test(name)) return name + '幢'
    return name
  }
}

export function formatBuildingAddress(subareaName, buildingName, isEn) {
  if (isEn) {
    return toPinyin(subareaName) + ', ' + formatBuildingName(buildingName, isEn)
  }
  return (subareaName || '') + ' ' + formatBuildingName(buildingName, isEn)
}

export function formatHouseSelectName(label) {
  if (!label) return label
  const str = String(label)
  const en = str
    .replace(/^(\d+)\s*号楼$/, 'Building $1')
    .replace(/^([A-Za-z0-9]+)\s*[号幢栋]$/, 'Building $1')
    .replace(/^(\d+)\s*单元$/, 'Unit $1')
    .replace(/^(\d+)\s*层$/, 'Floor $1')
    .replace(/^(\d+)\s*室$/, 'Room $1')
  // 仍有中文(如小区名等专有名词),转拼音
  return /[一-龥]/.test(en) ? toPinyin(str) : en
}

export function formatHouseAddress(fullName, subareaName, isEn) {
  if (!fullName) return ''

  if (!isEn) {
    return subareaName ? subareaName + ' ' + fullName : fullName
  }

  var bld
  var m = fullName.match(/^(\d+)[号幢栋]$/)
  if (m) {
    bld = 'Building ' + m[1]
  } else if (/^\d+$/.test(fullName)) {
    bld = 'Building ' + fullName
  } else {
    bld = toPinyin(fullName)
  }

  return subareaName ? toPinyin(subareaName) + ', ' + bld : bld
}
